import { createSelector } from 'reselect';

const selectCache = (state: any) => state.announcementCache;

export const selectListAnnouncements = createSelector(
  selectCache,
  (cache: any) => cache.listAnnouncements
);

export const selectProcessing = createSelector(
  selectCache,
  (cache: any) => cache.processing
);
